import {priceLivingNew, priceHourNew} from "./priceNew";

export default class ServiceCalc {

    static get selectors() {
        return {
            main: '.b-service-calc',
            complexity: '.js-complexity-mod',
            category: '.js-category-mod',
            pack: '.js-pack-mod',
            summaryValue: '.js-summary-value',
            benefitValue: '.js-benefit-value'
        }
    }

    static get classes() {
        return {
            packActive: 'b-service-calc__pack_active'
        }
    }

    static get dataSelectors() {
        return {
            complexity: 'complexity',
            category: 'category',
            pack: 'pack',
            calcMode: 'calc-mode',
            priceList: 'price-list'
        }
    }

    static init(context = $(document), options = {}) {
        $(ServiceCalc.selectors.main, context).each( (i, elem) => {
            if(!$(elem).hasClass('js-init')) return;
            if($(elem).data('block-api')) return;

            new ServiceCalc($(elem), options);
        })
    }

    constructor($elem, options) {

        this.params = $.extend({
            selectors: ServiceCalc.selectors,
            classes: ServiceCalc.classes,
            dataSelectors: ServiceCalc.dataSelectors
        }, options);

        this.elems = {
            $main: $elem,
            $complexity: $elem.find(this.params.selectors.complexity),
            $summaryValue: $elem.find(this.params.selectors.summaryValue),
            $category: $elem.find(this.params.selectors.category),
            $pack: $elem.find(this.params.selectors.pack),
            $benefitValue: $elem.find(this.params.selectors.benefitValue)
        };

        this.state = {
            complexity: this.elems.$complexity.eq(0).data(this.params.dataSelectors.complexity),
            category: this.elems.$category.eq(0).data(this.params.dataSelectors.category),
            pack: this.elems.$pack.eq(0).data(this.params.dataSelectors.pack),
            calcMode: this.elems.$main.data(this.params.dataSelectors.calcMode),
        };

        this.priceList = this.elems.$main.data(this.params.dataSelectors.priceList)
        if(!this.priceList) return;

        this.handleModChange();
        this.initialPacksView();
        this.render();

        this.initBlockApi();

    }

    render() {
        const { complexity, pack, category } = this.state;

        const targetComplexity = this.priceList.complexity.find(complexityItem => complexityItem.value === complexity)
        const targetCategory = targetComplexity ? targetComplexity.categories.find(categoryItem => categoryItem.value === category) : null;
        const targetPack = targetCategory ? targetCategory.packs.find(packItem => Number(packItem.value) === Number(pack))  : null;

        this.elems.$summaryValue.text(targetPack.price)
        this.elems.$benefitValue.text(targetPack.economy)
    }

    handleItemChange(mode) {
        let $elem = null;
        let stateOption = ''

        switch (mode) {
            case 'complexity':
                $elem = this.elems.$complexity;
                stateOption = 'complexity'
                break;
            case 'category':
                $elem = this.elems.$category;
                stateOption = 'category';
                break;
            case 'pack':
                $elem = this.elems.$pack;
                stateOption = 'pack';
                break;
            default:
                return;
        }

        $elem.click((event) => {
            const $eventElem = $(event.currentTarget);

            $elem.removeClass(this.params.classes.packActive);
            $eventElem.addClass(this.params.classes.packActive);

            this.setState({
                [stateOption]: $eventElem.data(this.params.dataSelectors[stateOption])
            });

            this.render();
        })
    }

    handleModChange() {
        this.handleItemChange('complexity');
        this.handleItemChange('category');
        this.handleItemChange('pack');
    }

    initialPacksView() {
        this.elems.$complexity.eq(0).addClass(this.params.classes.packActive);
        this.elems.$pack.eq(0).addClass(this.params.classes.packActive);
        this.elems.$category.eq(0).addClass(this.params.classes.packActive);
    }

    setState(newState) {
        this.state = {
            ...this.state,
            ...newState
        }
    }

    initBlockApi() {
        this.elems.$main.data('block-api', this)
    }

}